import { memo } from 'react';

import type { FC, SVGAttributes } from 'react';

export interface InfoBlockIconProps extends SVGAttributes<SVGSVGElement> {
  className?: string;
}

const InfoBlockIcon2: FC<InfoBlockIconProps> = (props) => {
  return (
    <svg
      {...props}
      width='114'
      height='77'
      viewBox='0 0 114 77'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect x='24.5' y='18.5' width='79.6' height='53.6' fill='#CCCCE6' stroke='#404040' />
      <rect x='20.5' y='71.8' width='87.4' height='4.2' fill='#CCCCE6' stroke='#404040' />
      <circle cx='20' cy='18.4219' r='16.8613' fill='white' stroke='#404040' />
      <path
        d='M19.6696 22.2659H24.6916V23.9219H16.1776V23.4899L20.4076 18.9359C21.7216 17.5499 22.2976 16.6859 22.2976 15.6779C22.2976 14.4719 21.5236 13.5899 20.3176 13.5899C19.1116 13.5899 18.3016 14.5259 18.3016 15.7499C18.3016 16.0019 18.3376 16.3079 18.3916 16.6679H16.4656C16.3756 16.3439 16.3396 16.0019 16.3396 15.6419C16.3396 13.6979 17.9056 11.8439 20.3356 11.8439C22.6036 11.8439 24.2776 13.4459 24.2776 15.5339C24.2776 16.3439 24.0616 17.0819 23.6296 17.7479C23.2156 18.4139 22.5856 19.1699 21.7576 20.0519L19.6696 22.2659Z'
        fill='#404040'
      />
      <path
        d='M64.3528 67.5289V24.0001M76.7056 62.8231H52M52 62.8231V24.0001L76.7056 24V67.5289H52V62.8231ZM52 36.3529H76.7056M52 58.7055H76.7056M52 47.5292H64.3528'
        stroke='#404040'
        strokeMiterlimit='10'
      />
    </svg>
  );
};

export default memo(InfoBlockIcon2);
